import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
// import { LoanApi } from '@apply/api';
// import { applicationInsights } from '../../../ApplicationInsights';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export const ExportIncompleteApplicationsButton = () => {
    // const loanApi = new LoanApi.LoanApi(applicationInsights);

    const handleClick = async () => {
        alert('In Development.');
    };

    return (
        <Button
            id='exportApplicationsButton'
            dataTestid='exportApplicationsButton'
            theme={ButtonTheme.SectionHeaderBarButton_Blue}
            width='100px'
            height='32px'
            borderRadius={ButtonBorderRadius.Small}
            handleClick={handleClick}
            icon={faDownload}
        >
            Export
        </Button>
    );
};
